import { FilterSections } from './filter_sections';
import { Filters } from './filters';

const FiltersByFilterSections = {
    [FilterSections.TYRE_INDEX_VIEW]: [
        Filters.LOAD_INDEX,
        Filters.SPEED_INDEX
    ],
    [FilterSections.BRAND_VIEW]: [
        Filters.MANUFACTURER,
        Filters.MODEL
    ],
    [FilterSections.PRICE_VIEW]: [
        Filters.PRICE_MIN,
        Filters.PRICE_MAX
    ],
    [FilterSections.DEALS_VIEW]: [
        Filters.FREE_FITTING,
        Filters.BUY_4_PAY_3,
        Filters.INSTANT_CASH,
        Filters.CLEARANCE,
        Filters.DISCOUNT_INSTANT_CASH_50,
        Filters.DISCOUNT_INSTANT_CASH_80,
        Filters.DISCOUNT_INSTANT_CASH_100,
        Filters.DISCOUNT_INSTANT_CASH_120,
        Filters.DISCOUNT_INSTANT_CASH_150,
        Filters.DISCOUNT_INSTANT_CASH_160,
        Filters.DISCOUNT_INSTANT_CASH_200,
        Filters.DISCOUNT_INSTANT_CASH_250,
        Filters.DISCOUNT_INSTANT_CASH_300,
        Filters.DISCOUNT_5_OFF,
        Filters.DISCOUNT_10_OFF,
        Filters.DISCOUNT_15_OFF,
        Filters.DISCOUNT_20_OFF,
        Filters.DISCOUNT_25_OFF,
        Filters.PROMO_GIFT_CARD_50,
        Filters.PROMO_GIFT_CARD_80,
        Filters.PROMO_GIFT_CARD_100,
        Filters.PROMO_GIFT_CARD_130,
        Filters.PROMO_GIFT_CARD_150,
        Filters.PROMO_GIFT_CARD_200,
        Filters.PROMO_GIFT_CARD_250,
    ],
    [FilterSections.FEATURES_VIEW]: [
        Filters.RUN_FLAT
    ],
    [FilterSections.QUALITY_SEGMENT_VIEW]: [
        Filters.QUALITY_SEGMENT_PREMIUM,
        Filters.QUALITY_SEGMENT_VALUE,
        Filters.QUALITY_SEGMENT_BUDGET,
    ],
    [FilterSections.ADDITIONAL_VIEW]: [
        Filters.VEHICLE_TYPE
    ],
    [FilterSections.WHEEL_BRAND_VIEW]: [
        Filters.MANUFACTURER,
        Filters.WHEEL_MODEL
    ],
    [FilterSections.WHEEL_SIZE_VIEW]: [
        Filters.WHEEL_DIAMETER,
        Filters.WHEEL_WIDTH
    ],
    [FilterSections.WHEEL_BOLT_PATTERN_VIEW]: [
        Filters.WHEEL_STUDS,
        Filters.WHEEL_PCD
    ],
    [FilterSections.USAGE_VIEW]: [
        Filters.USAGE
    ],
    [FilterSections.SEASON_VIEW]: [
        Filters.SEASON
    ],
    [FilterSections.EV_VIEW]: [
        Filters.EV
    ],
    [FilterSections.TECHNOLOGY_VIEW]: [
        Filters.TECHNOLOGY
    ],
    [FilterSections.TYRE_RATINGS_VIEW]: [
        Filters.LABEL_NOISE,
        Filters.LABEL_WET_GRIP,
        Filters.LABEL_FUEL_EFFICIENCY,
        Filters.UTQG_TREADWEAR_GROUP,
        Filters.UTQG_TRACTION,
        Filters.UTQG_TEMPERATURE,
    ],
    [FilterSections.CUSTOMER_REVIEWS_VIEW]: [
        Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP,
        Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP,
    ],
};

export { FiltersByFilterSections };